import Vue from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { mapGetters } from 'vuex';
let isMouseSliderFirstChange = false;
let itemsIsReducingNow = false;
function handleChangeReducedByMaximalsItemsList(newArray) {
    if (newArray.length === 0)
        return;
    const onlyItemsValues = newArray.reduce((arr, current) => {
        arr.push(...current.items.map((item) => item.val));
        return arr;
    }, []);
    if (onlyItemsValues.every((item) => item === onlyItemsValues[0])) {
        this.temporaryMultiLeverageValue = onlyItemsValues[0];
        this.sliderHadPresetState = false;
    }
    else {
        this.temporaryMultiLeverageValue = 1;
        this.sliderHadPresetState = true;
    }
    const onlyItemsMarginTypes = newArray.reduce((arr, current) => {
        arr.push(...current.items.map((item) => item.marginType));
        return arr;
    }, []);
    if (onlyItemsMarginTypes.every((item) => item === onlyItemsMarginTypes[0])) {
        this.selectedMarginType = onlyItemsMarginTypes[0] ? this.$t('leveragesPage.isolated') : this.$t('leveragesPage.cross');
    }
    else
        this.selectedMarginType = 'none';
    setTimeout(() => {
        itemsIsReducingNow = false;
    }, 750);
}
export default Vue.extend({
    name: 'multiSettingLeverages',
    props: {
        baseList: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        selectedLeveragesMaximum: 0,
        selectedMarginType: 'none',
        temporaryMultiLeverageValue: 1,
        sliderHadPresetState: true,
        isUserChangeMargin: false
    }),
    watch: {
        selectedLeveragesMaximum() {
            this.sliderHadPresetState = true;
            this.temporaryMultiLeverageValue = 1;
            this.$nextTick(() => {
                const $fakeSliderDot = document.getElementById('fakeSliderDot');
                if ($fakeSliderDot) {
                    $fakeSliderDot.style.left = '0';
                }
            });
        },
        temporaryMultiLeverageValue(newValue) {
            if (!itemsIsReducingNow && !this.sliderHadPresetState) {
                const reducedPayload = this.reducedByMaximumItems.reduce((newArray, current) => {
                    newArray.push(...current.items.map((item) => ({ id: item.id, value: newValue })));
                    return newArray;
                }, []);
                this.$emit('onTryApplyNewLeveragesValue', reducedPayload);
            }
        },
        selectedMarginType(newValue) {
            if (newValue !== 'none' && this.isUserChangeMargin) {
                const reducedPayload = this.reducedByMaximumItems.reduce((newArray, current) => {
                    newArray.push(...current.items.map((item) => ({ id: item.id, marginType: newValue })));
                    return newArray;
                }, []);
                this.$emit('onTryApplyNewMarginType', reducedPayload);
                this.isUserChangeMargin = false;
            }
        }
    },
    computed: Object.assign(Object.assign({}, mapGetters('mainPageModules', {
        getFuturesSettings: 'getFuturesSettings'
    })), { temporaryMultiLevarageMax() {
            return this.selectedLeveragesMaximum ? this.reducedMaximalsOfSelectedItems[this.selectedLeveragesMaximum - 1] : this.reducedMaximalsOfSelectedItems[0];
        },
        reducedMaximalsOfSelectedItems() {
            const vm = this;
            const result = [];
            vm.baseList.forEach((folder) => {
                folder.items.forEach((item) => {
                    if (item.selected && !result.includes(item.max))
                        result.push(item.max);
                });
            });
            result.sort((a, b) => a < b ? -1 : 1);
            return result;
        },
        reducedByMaximumItems() {
            itemsIsReducingNow = true;
            const vm = this;
            const selectedMaximum = vm.selectedLeveragesMaximum ? vm.reducedMaximalsOfSelectedItems[vm.selectedLeveragesMaximum - 1] : 20;
            const result = vm.baseList.reduce((arr, current) => {
                const filtredByMaximumItemsOfFolder = current.items.filter((item) => {
                    if (vm.selectedLeveragesMaximum) {
                        return item.max === selectedMaximum && item.selected;
                    }
                    else
                        return item.selected;
                });
                if (filtredByMaximumItemsOfFolder.length) {
                    arr.push({
                        name: current.default_folder ? this.$t('leveragesPage.outsideOfFolder') : current.name,
                        items: filtredByMaximumItemsOfFolder
                    });
                }
                return arr;
            }, []);
            handleChangeReducedByMaximalsItemsList.call(this, result);
            return result;
        } }),
    filters: {
        filterMaximalsToSelect(value, vm) {
            const result = value.map((item, index) => ({ key: index + 1, value: item.toString() }));
            result.unshift({ key: 0, value: vm.$t('leveragesPage.all') });
            return result;
        }
    },
    methods: {
        handleClickSetSliderMinimum() {
            if (this.sliderHadPresetState) {
                this.sliderHadPresetState = false;
                const reducedPayload = this.reducedByMaximumItems.reduce((newArray, current) => {
                    newArray.push(...current.items.map((item) => ({ id: item.id, value: 1 })));
                    return newArray;
                }, []);
                this.$emit('onTryApplyNewLeveragesValue', reducedPayload);
            }
            this.temporaryMultiLeverageValue = 1;
        },
        handleSliderMouseup(event) {
            if (this.sliderHadPresetState) {
                isMouseSliderFirstChange = true;
                const { slider: sliderRef } = this.$refs;
                const sliderRect = sliderRef.$el.getBoundingClientRect();
                let mousePositionPercent = (event.pageX - sliderRef.$el.getBoundingClientRect().x) / sliderRect.width;
                if (mousePositionPercent < 0)
                    mousePositionPercent = 0;
                const sliderMin = 1;
                const sliderMax = this.temporaryMultiLevarageMax;
                const $tooltip = document.querySelector('.leverages_aside_custom-tooltip-on-hover');
                if ($tooltip) {
                    $tooltip.style.transition = 'ease-in-out 0.6s';
                    $tooltip.style.left = '0';
                    $tooltip.style.visibility = 'hidden';
                }
                const $fakeSliderDot = document.getElementById('fakeSliderDot');
                if ($fakeSliderDot) {
                    $fakeSliderDot.classList.add('leverages_aside_slider-dot--inactive');
                    $fakeSliderDot.style.transition = 'ease-in-out 0.6s';
                    $fakeSliderDot.style.left = '0';
                }
                const $fakeSliderProccess = document.getElementById('fakeSliderProcess');
                if ($fakeSliderProccess) {
                    $fakeSliderProccess.style.width = '0px';
                }
                setTimeout(() => {
                    this.temporaryMultiLeverageValue = Math.round((sliderMax - sliderMin) * mousePositionPercent + sliderMin);
                    this.sliderHadPresetState = false;
                }, 10);
            }
        },
        handleSliderMinMaxMouseenter(isMax) {
            if (!this.sliderHadPresetState)
                return;
            const { slider: sliderRef } = this.$refs;
            const $tooltip = document.querySelector('.leverages_aside_custom-tooltip-on-hover');
            if ($tooltip) {
                const sliderRect = sliderRef.$el.getBoundingClientRect();
                $tooltip.style.transition = 'ease-in-out 0.6s';
                $tooltip.style.left = (isMax ? 100 : 0) + '%';
                $tooltip.style.visibility = 'visible';
                const $childrenTextNode = $tooltip.querySelector('.v-tooltip__content');
                if ($childrenTextNode)
                    $childrenTextNode.innerText = (isMax ? this.temporaryMultiLevarageMax : 1) + '';
                const $fakeSliderDot = document.getElementById('fakeSliderDot');
                if ($fakeSliderDot) {
                    $fakeSliderDot.style.transition = 'ease-in-out 0.6s';
                    $fakeSliderDot.style.left = (isMax ? 1 * sliderRect.width : 0) + 'px';
                    $fakeSliderDot.classList.remove('leverages_aside_slider-dot--inactive');
                }
                const $fakeSliderProccess = document.getElementById('fakeSliderProcess');
                if ($fakeSliderProccess) {
                    $fakeSliderProccess.style.transition = 'ease-in-out 0.6s';
                    $fakeSliderProccess.style.width = (isMax ? 1 * sliderRect.width : 0) + 'px';
                }
            }
        },
        handleSliderMinMaxMouseleave() {
            if (!this.sliderHadPresetState)
                return;
            const $tooltip = document.querySelector('.leverages_aside_custom-tooltip-on-hover');
            if ($tooltip) {
                $tooltip.style.transition = 'ease-in-out 0.6s';
                $tooltip.style.left = '0';
                $tooltip.style.visibility = 'hidden';
            }
            const $fakeSliderDot = document.getElementById('fakeSliderDot');
            if ($fakeSliderDot) {
                $fakeSliderDot.classList.add('leverages_aside_slider-dot--inactive');
                $fakeSliderDot.style.transition = 'ease-in-out 0.6s';
                $fakeSliderDot.style.left = '0';
            }
            const $fakeSliderProccess = document.getElementById('fakeSliderProcess');
            if ($fakeSliderProccess) {
                $fakeSliderProccess.style.width = '0px';
            }
        },
        handleSliderMouseenter() {
            if (this.sliderHadPresetState) {
                const { slider: sliderRef } = this.$refs;
                const mouseleaveHandler = () => {
                    document.onmousemove = null;
                    sliderRef.$el.onmouseleave = null;
                    const $tooltip = document.querySelector('.leverages_aside_custom-tooltip-on-hover');
                    if ($tooltip) {
                        $tooltip.style.transition = 'ease-in-out 0.6s';
                        $tooltip.style.left = '0';
                        $tooltip.style.visibility = 'hidden';
                    }
                    const $fakeSliderDot = document.getElementById('fakeSliderDot');
                    if ($fakeSliderDot) {
                        $fakeSliderDot.classList.add('leverages_aside_slider-dot--inactive');
                        $fakeSliderDot.style.transition = 'ease-in-out 0.6s';
                        $fakeSliderDot.style.left = '0';
                    }
                    const $fakeSliderProccess = document.getElementById('fakeSliderProcess');
                    if ($fakeSliderProccess) {
                        $fakeSliderProccess.style.transition = 'ease-in-out 0.6s';
                        $fakeSliderProccess.style.width = '0px';
                    }
                };
                const mousemoveHandler = (event) => {
                    const sliderRect = sliderRef.$el.getBoundingClientRect();
                    if (event.pageX > sliderRect.x && event.pageX < sliderRect.x + sliderRect.width) {
                        let mousePositionPercent = (event.pageX - sliderRef.$el.getBoundingClientRect().x) / sliderRect.width;
                        if (mousePositionPercent < 0)
                            mousePositionPercent = 0;
                        const sliderMin = 1;
                        const sliderMax = this.temporaryMultiLevarageMax;
                        const $tooltip = document.querySelector('.leverages_aside_custom-tooltip-on-hover');
                        if ($tooltip) {
                            $tooltip.style.transition = 'none';
                            $tooltip.style.visibility = 'visible';
                            $tooltip.style.left = mousePositionPercent * 100 + '%';
                            const $childrenTextNode = $tooltip.querySelector('.v-tooltip__content');
                            if ($childrenTextNode)
                                $childrenTextNode.innerText = Math.round((sliderMax - sliderMin) * mousePositionPercent + sliderMin) + '';
                            const $fakeSliderDot = document.getElementById('fakeSliderDot');
                            if ($fakeSliderDot) {
                                $fakeSliderDot.classList.remove('leverages_aside_slider-dot--inactive');
                                $fakeSliderDot.style.transition = 'none';
                                $fakeSliderDot.style.left = mousePositionPercent * sliderRect.width + 'px';
                            }
                            const $fakeSliderProccess = document.getElementById('fakeSliderProcess');
                            if ($fakeSliderProccess) {
                                $fakeSliderProccess.style.transition = 'none';
                                $fakeSliderProccess.style.width = mousePositionPercent * sliderRect.width + 'px';
                            }
                        }
                    }
                };
                document.onmousemove = mousemoveHandler;
                sliderRef.$el.onmouseleave = mouseleaveHandler;
            }
        }
    },
    components: {
        VueSlider
    }
});
